/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {dlsColor} from '../../theme/theme';
import {IconProps} from '../../types/types';
import useIconDLS from '../useIconDLS';

/*
 * Defines the Design Language System (DLS) Side Nav Eye Logo Icon component.
 */
export const SideNavEyeLogoIcon = (props: IconProps) => {
  const {iconSize} = useIconDLS(props);
  const width      = iconSize === 32 ? 32 : 48;
  const height     = iconSize === 32 ? 26 : 40;

  return (
    <svg width={width}
      height={height}
      viewBox='0 0 48 40'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#clip0_19114_4239)'>
        <path d='M44.9392 19.2278C41.5222 14.4704 36.975 11.0799 31.898 9.34912C33.5932 10.6184 34.9707 12.287 35.9066 14.213C38.2553 15.713 40.392 17.6568 42.2109 20.0089C40.392 22.361 38.2553 24.3047 35.9066 25.7959C35.5446 26.0266 35.1737 26.2485 34.8029 26.4615C29.9819 29.1686 22.6093 31.0769 17.9737 27.0651C13.7267 23.3905 13.7267 16.6095 17.9737 12.9349C16.2873 13.4586 14.6538 14.1953 13.1175 15.145C11.7577 18.216 11.7577 21.784 13.1175 24.855C13.2852 25.2278 13.4707 25.5917 13.6737 25.9468C13.9033 26.3462 14.1505 26.7278 14.4242 27.0917C15.9606 29.1864 18.1592 30.7574 20.6403 31.4941C23.5099 32.3462 26.6885 32.0089 29.5581 31.3343C30.3528 31.1479 31.1386 30.926 31.9068 30.6598C36.9838 28.929 41.531 25.5385 44.9481 20.7811L45.5043 20L44.9481 19.2189L44.9392 19.2278Z'
          fill='#07BCDE' />
        <path d='M12.0845 25.7958C9.73585 24.2958 7.5991 22.352 5.7802 20.0088C8.08472 17.0355 11.025 14.5591 14.4067 12.9171C18.486 10.929 24.2428 9.50884 28.4545 11.8432C34.0348 14.9408 34.8471 22.8935 30.0174 27.0651C31.7038 26.5414 33.3373 25.8047 34.8736 24.855C36.2334 21.784 36.2334 18.2159 34.8736 15.1449C34.7059 14.7722 34.5205 14.4082 34.3174 14.0532C34.0878 13.6538 33.8406 13.2722 33.5669 12.9082C32.0305 10.8136 29.8319 9.24257 27.3508 8.50588C24.4812 7.65381 21.3026 7.99109 18.433 8.66564C17.6383 8.85203 16.8525 9.07393 16.0843 9.3402C11.0161 11.0798 6.47774 14.4704 3.05187 19.2278L2.49561 20.0088L3.05187 20.7899C6.46891 25.5473 11.0161 28.9378 16.0931 30.6686C14.3979 29.3994 13.0205 27.7307 12.0845 25.7958Z'
          fill='#81DEF2' />
        <path d='M23.9999 27.5453C20.8913 27.5453 18.0299 25.5391 16.9525 22.6098C15.8662 19.6449 16.7847 16.2274 19.2045 14.2035C21.6243 12.1795 25.148 11.9044 27.8504 13.5288C30.5352 15.1533 31.9658 18.3667 31.3653 21.4647C30.6853 24.9533 27.5325 27.5542 23.9999 27.5542V27.5453ZM23.9999 15.1178C19.5489 15.1178 17.4824 20.9054 20.9001 23.7549C24.3002 26.5955 29.5372 23.533 28.7865 19.1656C28.3891 16.8576 26.3314 15.1178 23.9999 15.1178Z'
          fill='#02ABCA' />
      </g>
      <defs>
        <clipPath id='clip0_19114_4239'>
          <rect width='43.0088' height='24.0029' fill={dlsColor('white')} transform='translate(2.49561 7.99854)' />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SideNavEyeLogoIcon;
